import React from 'react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { Grid } from 'react-awesome-spinners';
import { BUDGETS, organizationBEABudget, BUDGETS_ORG_WISE, BUDGETS_BEA_ORG_WISE } from '../graphql';
import { currencyDisplayRenderer } from '../util';
import { Table,
  TableHeadingWrap,
  Header,
  TableActionsWrap,
  TableAction, GridLoader } from '../components';

const AllBudgetsOrgWise = props => {
  const { account } = props;
  const { accessibles } = account;
  //console.log("All accessibles" , accessibles);

  const query = { organization_unit: { in: accessibles.budgetOrgs } };

  const { loading, error, data } = useQuery(BUDGETS_ORG_WISE, { variables: { where: query } });
  
  const currentYear = new Date().getFullYear().toString();
  const beaBudgetQuery = { year: { eq: currentYear} };
  const { loading: beaBudgetLoding, error: beaBudgetError, data: beaBudgetData } = useQuery(organizationBEABudget, { variables: { where: beaBudgetQuery } });
    const beaBudgetResponseData = beaBudgetData && beaBudgetData.organizationBEABudget;

  console.log("beaBudgetResponseData" , beaBudgetResponseData);  

  {/*  INITIALIZED THE TOTAL VARIABLES TO FIX THE DEFECT 12 OF BUDGET */}
  let totalBudget = 0;
  let totalInProgress = 0;
  let totalSpent = 0;
  let totalAvailFore = 0;
  let totalAvailable = 0;

  
  return (
    <>   
      <Header {...props}/>
      <TableHeadingWrap>
        <h2 style={{ width: "100%", float: "left" }}>
          <span>Organization Wise Budget Display</span>
          <span style={{'float': 'right'}}><button onClick={() => window.history.back()}>Go Back</button></span>
        </h2>
      </TableHeadingWrap>
      <h3>Offcycle Budget</h3>
      <div className="table-wrapper">
        <table className="responsive-table">
          <thead>
            <tr>
              <th>Organization Name</th>
              <th>Organization Unit</th>
              <th>Budget Spent</th>
              
            </tr>
          </thead>
          <tbody>
            {
              console.log("data===>", data)
            }  
            {data?.budgetsOrgWise?.items?.map((item) => (
              <tr>
                <td>{item.org.organization_unit_name}</td>
                <td>{item.org.organization_unit}</td>
                <td>{item.budget_spent}</td>
                
              </tr>  
              
          ))}
          </tbody>
        </table>
      </div>

      
          
          </>
  );
}

const mapStateToProps = state => {
  return {
    account: state.account
  };
};

export default connect(
  mapStateToProps
)(AllBudgetsOrgWise);
